import * as React from 'react';
import {StyleSheet, View, Text, ImageBackground} from 'react-native';
import {
  Border,
  Color,
  FontFamily,
  FontSize,
  Padding,
} from './card.common.styles';
import {designToDp} from '@utils';

interface CardProps {
  onPress?: () => void;
  data: any;
}
const Card = (props: CardProps) => {
  const {onPress, data} = props;
  return (
    <View>
      <View style={styles.property1cardInner}>
        <View style={[styles.frameChild, styles.framePosition]} />
        <ImageBackground source={{uri: data.src}} style={styles.backImg} />
      </View>
      <View style={[styles.parent, styles.parentFlexBox]}>
        <Text style={[styles.text, styles.textLayout]}>₹{data.price}</Text>
        <View style={[styles.tryNowWrapper, styles.parentFlexBox]}>
          <Text style={[styles.tryNow, styles.text1Typo]} onPress={onPress}>
            try now
          </Text>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  backImg: {
    flex: 1,
    esizeMode: 'cover',
  },
  framePosition: {
    left: 0,
    top: 0,
    height: designToDp(114),
    width: designToDp(172),
    position: 'absolute',
    overflow: 'hidden',
  },
  parentFlexBox: {
    alignItems: 'center',
    flexDirection: 'row',
  },
  textLayout: {
    height: designToDp(14),
    width: designToDp(66),
    fontFamily: FontFamily.interBold,
    fontWeight: '700',
  },
  text1Typo: {
    fontSize: FontSize.size_3xs,
    textAlign: 'left',
    letterSpacing: -0.2,
  },
  textTypo: {
    textAlign: 'left',
    color: Color.color2,
    letterSpacing: -0.2,
    fontSize: FontSize.size_xs,
  },
  frameChild: {
    overflow: 'hidden',
    backgroundColor: '#e8ebef',
  },
  property1cardInner: {
    height: designToDp(114),
    width: designToDp(172),
  },
  text: {
    textAlign: 'left',
    color: Color.color2,
    letterSpacing: -0.2,
    fontSize: FontSize.size_xs,
    height: 14,
    width: 66,
  },
  tryNow: {
    textTransform: 'capitalize',
    fontWeight: '500',
    fontFamily: FontFamily.interMedium,
    color: Color.color,
  },
  tryNowWrapper: {
    borderRadius: Border.br_9xs,
    borderStyle: 'solid',
    borderColor: '#d8e0ea',
    paddingHorizontal: Padding.p_5xs,
    paddingVertical: Padding.p_9xs,
    justifyContent: 'center',
    backgroundColor: Color.white,
    alignItems: 'center',
    flexDirection: 'row',
    borderWidth: 1,
  },
  parent: {
    backgroundColor: '#fff',
    height: 40,
    padding: Padding.p_5xs,
    justifyContent: 'space-between',
    width: designToDp(172),
    alignItems: 'center',
    flexDirection: 'row',
  },
  property1card: {
    top: 23,
    left: 20,
    backgroundColor: Color.white,
  },
  frameItem: {
    backgroundColor: '#e8ebee',
  },
  free: {
    fontFamily: FontFamily.interBold,
    fontWeight: '700',
    textAlign: 'left',
    color: Color.color2,
    letterSpacing: -0.2,
    fontSize: FontSize.size_xs,
  },
  text1: {
    textDecorationStyle: 'line-through',
    // textDecoration: 'line-through',
    color: Color.color1,
    height: designToDp(14),
    width: designToDp(66),
    fontFamily: FontFamily.interBold,
    fontWeight: '700',
  },
  property1card1: {
    top: 20,
    left: 221,
    backgroundColor: Color.white,
  },
  card: {
    borderRadius: 5,
    borderStyle: 'dashed',
    borderColor: '#9747ff',
    width: designToDp(413),
    height: designToDp(197),
    overflow: 'hidden',
    borderWidth: 1,
  },
});

export default Card;
